import iconOne from '../../assets/service/1.png';
import iconTwo from '../../assets/service/2.png';
import iconThree from '../../assets/service/3.png';
import iconFour from '../../assets/service/4.png';

const ServicesData = [
    {
    'icon': iconFour,
    'title': 'Root Canal',
    'description': 'Advanced root canal therapy to preserve and restore severely damaged or infected teeth painlessly.',
},
    {
    'icon': iconOne,
    'title': 'Dentures',
    'description': 'Custom-made dentures designed to restore comfort, aesthetics, and functionality to patients with missing teeth.',
},
{
    'icon': iconTwo,
    'title': 'Implants',
    'description': 'Permanent dental implants provide a durable and natural-looking solution for missing teeth replacement.',
},
{
    'icon': iconThree,
    'title': 'Whitening',
    'description': 'Professional teeth whitening treatments to enhance your smile by removing stains and discoloration effectively.',
},
// {
//     'icon': iconFour,
//     'title': 'Root Canal',
//     'description': 'Advanced root canal therapy to preserve and restore severely damaged or infected teeth painlessly.',
// }

]

export default ServicesData;